module.exports = __webpack_public_path__ + "static/media/0026_IMG_LE_SOL_MEGALITH_MEGABROWN.76fe1074.png";